import { render, staticRenderFns } from "./work-table.vue?vue&type=template&id=051f95c1&scoped=true"
import script from "./work-table.vue?vue&type=script&lang=js"
export * from "./work-table.vue?vue&type=script&lang=js"
import style0 from "./work-table.vue?vue&type=style&index=0&id=051f95c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051f95c1",
  null
  
)

export default component.exports